import { Map } from 'immutable';
import { ChannelStatusId, ChannelStatusResponse } from './types';
import { parametric, pathSubscription, subscription } from 'nike-re-framejs';
import { CashinClosingState, CashinTransactionStatus } from '../../../types/cashin-closing';

export const isCashinEnabledByChannelStatusKey$$ = parametric((channelStatusKeys: string[]) =>
    subscription(
        (statuses: Map<string, ChannelStatusResponse>) =>
            channelStatusKeys.every(key => isChannelStatusEnabled(statuses.get(key))),
        pathSubscription(['ticketus', 'cashin', 'channelStatus'], Map())
    )
);

export const isChannelStatusEnabled = (channelStatus?: ChannelStatusResponse) => {
    return channelStatus && channelStatus.e && !channelStatus.d;
};

export const changeStatusToKey = (channelStatusId: ChannelStatusId) => {
    if (channelStatusId) {
        return `${channelStatusId.c}-${channelStatusId.g}-${channelStatusId.p}`;
    }
    return '';
};

export function getCashinClosingDialogState({ cashinOffer, cashinTransaction }) {
    if (!cashinOffer) {
        return CashinClosingState.NOT_AVAILABLE;
    }
    if (!cashinTransaction || isTransactionRunning(cashinTransaction.status)) {
        return CashinClosingState.IN_PROGRESS;
    }
    if (cashinTransaction.status === CashinTransactionStatus.Approved) {
        return CashinClosingState.RESULT;
    }
    if (cashinTransaction.status === CashinTransactionStatus.Rejected) {
        return CashinClosingState.ERROR;
    }

    return CashinClosingState.NOT_AVAILABLE;
}

export function isTransactionRunning(cashinTransactionStatus) {
    return (
        cashinTransactionStatus === CashinTransactionStatus.Started ||
        cashinTransactionStatus === CashinTransactionStatus.Activated
    );
}
